<template>
    <div>
        <header class="text-left search_equipment d-flex user-detail row">
            <div class="col-md-8 d-flex justify-content-between mx-3 mx-md-auto align-items-center">
                <b-img :src="require('@/assets/small-logo.png')" width="35" height="40"></b-img>
                <div class="d-flex align-items-center gap-3">
                    <!-- <div class="position-relative mr-3">
                        <svg width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M22.1609 15.7696L19.8273 13.436V10.3447C19.8246 8.20836 19.0299 6.14891 17.5968 4.56457C16.1638 2.98023 14.1941 1.98353 12.0688 1.76721V0H10.3447V1.76721C8.21934 1.98353 6.2497 2.98023 4.81663 4.56457C3.38355 6.14891 2.58884 8.20836 2.58617 10.3447V13.436L0.252582 15.7696C0.0909043 15.9312 4.88246e-05 16.1505 0 16.3791V18.9652C0 19.1939 0.0908235 19.4131 0.25249 19.5748C0.414157 19.7365 0.633425 19.8273 0.862056 19.8273H6.89645V20.4971C6.8777 21.5907 7.26317 22.6528 7.979 23.4799C8.69484 24.3069 9.69068 24.8407 10.7757 24.9789C11.375 25.0384 11.9801 24.9717 12.552 24.7832C13.124 24.5948 13.6502 24.2887 14.0968 23.8847C14.5434 23.4806 14.9004 22.9876 15.145 22.4373C15.3896 21.887 15.5163 21.2916 15.517 20.6893V19.8273H21.5514C21.78 19.8273 21.9993 19.7365 22.161 19.5748C22.3226 19.4131 22.4135 19.1939 22.4135 18.9652V16.3791C22.4134 16.1505 22.3226 15.9312 22.1609 15.7696ZM13.7929 20.6893C13.7929 21.3752 13.5204 22.033 13.0354 22.518C12.5504 23.003 11.8926 23.2755 11.2067 23.2755C10.5208 23.2755 9.86303 23.003 9.37803 22.518C8.89303 22.033 8.62056 21.3752 8.62056 20.6893V19.8273H13.7929V20.6893ZM20.6893 18.1032H1.72411V16.736L4.0577 14.4024C4.21938 14.2407 4.31023 14.0215 4.31028 13.7929V10.3447C4.31028 8.51562 5.03687 6.76148 6.3302 5.46815C7.62354 4.17481 9.37768 3.44822 11.2067 3.44822C13.0358 3.44822 14.7899 4.17481 16.0833 5.46815C17.3766 6.76148 18.1032 8.51562 18.1032 10.3447V13.7929C18.1032 14.0215 18.1941 14.2407 18.3558 14.4024L20.6893 16.736V18.1032Z"
                                fill="white" />
                        </svg>
                        <div class="notifications-count" v-if="userNotifications && userNotifications.filter((notification)=>!notification.is_read).length">
                            {{ userNotifications.filter((notification)=>!notification.is_read).length }}
                        </div>
                    </div> -->
                    <LanguageFlagDropdown class="mr-3" />
                    <NotificationHeader />
                    <b-dropdown id="dropdown-right" right class="dropdown dropdown-dark-section header-section-dropdown">
                        <template slot="button-content" v-if="user">
                            <b-img v-if="user && user.team_member && user.team_member.profile_picture"
                                class="userSmallImage rounded-circle" :src="user.team_member.profile_picture"></b-img>
                            <div v-else class="user-default-img">
                                {{ user.first_name.charAt(0).toUpperCase() }}{{ user.last_name.charAt(0).toUpperCase() }}
                            </div>
                        </template>
                        <b-dropdown-item>
                            <div class="d-flex flex-column"><span class="font-weight-bold f-14">{{ user.first_name }} {{
                                user.last_name }}</span>
                                <span class="f-12">{{ user.email }}</span>
                            </div>
                        </b-dropdown-item>
                        <hr class="my-2" />
                        <!-- <b-dropdown-item to="/profile-page" v-if="userCompany"><span class="f-14">{{
                            $t('header.viewProfile') }}</span></b-dropdown-item> -->
                        <b-dropdown-item to="/all-companies"><span class="f-14">{{ $t('header.viewCompanies')
                        }}</span></b-dropdown-item>
                        <hr class="my-2" />
                        <b-dropdown-item @click="OnlogoutUser"><span class="f-14">{{ $t('header.logout')
                        }}</span></b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
        </header>
        <div class="row">
            <div class="col-md-8 mx-3 mx-md-auto pt-64">
                <div class="d-flex justify-content-between align-items-center mt-3 mb-3">
                    <h1 class="font-weight-bold f-32 mb-0">{{ $t('allCompaniesPage.title') }} </h1>
                    <!-- Add New Company Card -->
                    <b-button v-if="canAddCompany" @click="$router.push('/create-company')"
                        class="export equipment d-flex justify-content-center align-items-center w-fit-content"
                        variant="primary">
                        <b-icon icon="plus" aria-hidden="true"></b-icon>
                        <p class="mb-0 ml-2 text-white">{{ $t('allCompaniesPage.addCompany') }}</p>
                    </b-button>
                </div>
                <div class="companies-list-container">
                    <div v-for="(company, index) in userCompanies" :key="index">
                        <div class="company-section bg-white mb-3 cursor-pointer" @click="setUserCompany(company)">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center">
                                    <div class="companies-icon-section all-section">
                                        {{ company.name.charAt(0).toUpperCase() }}
                                    </div>
                                    <h3 class="font-weight-bold mb-0">{{ company.name }}</h3>
                                </div>
                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_9035_12233)">
                                        <path
                                            d="M12.5 0C5.60728 0 0 5.60728 0 12.5C0 19.3927 5.60728 25 12.5 25C19.3927 25 25 19.3927 25 12.5C25 5.60728 19.3927 0 12.5 0ZM16.3615 13.2365L11.1531 18.4448C10.95 18.6479 10.6833 18.75 10.4166 18.75C10.15 18.75 9.8833 18.6479 9.68018 18.4448C9.2729 18.0375 9.2729 17.3792 9.68018 16.9719L14.1521 12.5L9.68023 8.02812C9.27295 7.62085 9.27295 6.9625 9.68023 6.55522C10.0875 6.14795 10.7458 6.14795 11.1531 6.55522L16.3615 11.7636C16.7688 12.1708 16.7688 12.8292 16.3615 13.2365Z"
                                            fill="#2D69F6" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_9035_12233">
                                            <rect width="25" height="25" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template> 
<script>
import { mapGetters, mapActions } from "vuex";
import NotificationHeader from "@/components/Shared/NotificationHeader.vue";
import { clearGleapUser, initGleapWithUser, updateGleapContact } from "@/plugins/gleap";
import LanguageFlagDropdown from "@/components/Shared/LanguageFlagDropdown.vue";
import { takePendingRedirect } from "@/services/helper";
export default {
    name: "all-companies",
    components: { NotificationHeader, LanguageFlagDropdown },
    computed: {
        ...mapGetters(["userCompanies", 'user', 'userCompany', 'userNotifications']),
        canAddCompany() {
            return this.$store.state.user?.user?.team_member?.can_add_company || this.$store.state.user?.user?.can_add_company
        }
    },
    methods: {
        ...mapActions(["getUserCompanies", "logoutUser", "getUserByID", "setNotification", "getUserCompany", "createUserLogs", "getSubscriptionDetails"]),
        async setUserCompany(company) {
            if (company.subscription.status === 'inactive' && !company.subscription.is_in_trial && company.subscription.type === 'Stripe') {
                try {
                const url = await this.getSubscriptionDetails(company.id);
                    if (url) window.location.href = url
                }
                catch (e) {
                    console.log(e)
                }
            }
            else if (company.is_verified) {
                localStorage.setItem('userSelectedCompany', company.id)
                await this.createUserLogs({ action: 'login' });

                // Update Gleap contact with selected company data
                if (!process.env.VUE_APP_SHOW_INTERCOM) {
                    updateGleapContact(company);
                }

                this.getUserCompany()
                // Somebody who arrived on an authorization request has a company
                // to authorize against now, so they are sent back to finish it.
                const pending = takePendingRedirect();
                this.$router.push(pending || '/')
            }
            else {
                await this.setNotification({
                    msg: this.$t('allCompaniesPage.underVerification', { name: company.name }),
                    type: "error",
                    color: "red",
                });
            }
        },
        async OnlogoutUser() {
            if (localStorage.getItem('userSelectedCompany')) {
                await this.createUserLogs({ action: 'logout' });
            }
            this.logoutUser();
            if (!process.env.VUE_APP_SHOW_INTERCOM) {
                clearGleapUser();
            }
            this.$router.push("/login");
        },
    },
    async mounted() {
        await this.getUserByID();
        await this.getUserCompanies();

        // Initialize Gleap with user data (company will be updated when selected)
        if (!process.env.VUE_APP_SHOW_INTERCOM && this.user) {
            initGleapWithUser(this.user, null);
        }
    }
}
</script>
<style>
.company-section {
    border-radius: 5px;
    padding: 24px;
    border: 1px solid #dee2e6;
}

.company-section>div>div>h3 {
    font-size: 18px;
    margin-left: 3rem;
}

.company-section>div>button {
    padding: 10px 30px;
    font-size: 14px;
}

#dropdown-right-2 button {
    background-color: transparent !important;
    color: white !important;
    font-weight: 600;
    font-size: var(--small);
    border: unset;
}

.companies-icon-section {
    color: white;
    font-weight: 700;
    background: #2D69F6;
    min-width: 28px !important;
    max-width: 28px !important;
    height: 28px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    border-radius: 5px !important;
}

.companies-icon-section.all-section {
    min-width: 35px;
    max-width: 35px;
    height: 35px;
}

.companies-list-container {
    max-height: calc(100vh - 160px);
    overflow-y: auto;
}

@media screen and (max-width: 767px) {
    .company-section {
        padding: 16px;
    }

    .company-section>div>div>h3 {
        font-size: 14px;
        margin-left: 0.5rem;
    }

    .company-section>div>button {
        padding: .375rem .75rem;
    }
}

.add-company-card {
    border: 1px dashed #2D69F6;
    background-color: #f8faff !important;
}

.add-company-card:hover {
    background-color: #eef4ff !important;
}

.add-company-icon {
    background: #2D69F6;
}</style>